import React, { useState } from "react";
import {
  FaLaptop,
  FaNetworkWired,
  FaChalkboardTeacher,
  FaRegLightbulb,
} from "react-icons/fa";
import { TbAugmentedReality2 } from "react-icons/tb";
import { GiCyberEye } from "react-icons/gi";
import { RiCodeSSlashLine } from "react-icons/ri";
import { GrCloudComputer } from "react-icons/gr";
import { SiDatastax } from "react-icons/si";
import { GoGraph } from "react-icons/go";
import { BiAnalyse } from "react-icons/bi";
import { MdOutlineBusinessCenter } from "react-icons/md";
import {
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@mui/material";

interface Service {
  title: string;
  description: string;
}

const ServicesGrid: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [selectedService, setSelectedService] = useState<Service | null>(null);

  const handleOpen = (service: Service) => {
    setSelectedService(service);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedService(null);
  };

  const services: Service[] = [
    {
      title: "Dissertation",
      description:
        "Our company offers expert assistance for dissertation writing, including topic selection, research guidance, and thorough Project writing services. We ensure that your work meets academic standards and is tailored to your unique requirements. Let us help you succeed with personalized support at every stage of your dissertation process.",
    },
    {
      title: "Coursework",
      description:
        "Our company provides comprehensive coursework support, from topic selection to final submission. We offer research assistance, writing help, and thorough editing to ensure your coursework meets academic standards. Partner with us for personalized guidance and timely completion of your assignments.",
    },
    {
      title: "Data Analysis",
      description:
        "Our company specializes in data analysis services, offering expert support in collecting, processing, and interpreting data for academic projects. We use advanced tools and techniques to provide accurate and insightful analysis tailored to your research needs. Trust us to help you make informed decisions based on your data.",
    },
    {
      title: "Project writing services",
      description:
        "Our company offers professional Project writing services to refine your academic work with precision. We ensure clarity, coherence, and adherence to academic standards, while correcting grammar, formatting, and citation errors. Let us help you enhance the quality of your writing for a polished final submission.",
    },
    {
      title: "Publication",
      description:
        "Our company provides tailored Publication designed to enhance your academic skills, covering areas such as research methods, writing techniques, and data analysis. Each course is crafted to meet your specific learning goals and improve your overall performance. Enroll with us for expert-led, practical learning experiences.",
    },
    {
      title: "Literature Review",
      description:
        "Our company offers specialized literature review services, helping you identify, analyze, and synthesize key academic sources relevant to your research. We ensure a comprehensive and well-structured review that supports your research objectives. Trust us to provide thorough and insightful analysis for your literature review needs.",
    },
    {
      title: "Manuscript",
      description:
        "Our company provides expert manuscript services, assisting with everything from structuring to editing and polishing your academic work. We ensure clarity, coherence, and adherence to publication standards, helping you prepare your manuscript for submission with confidence. Let us refine your work for a successful publication process.",
    },
    {
      title: "Research Methodology",
      description:
        "Our company offers guidance in developing a robust research methodology tailored to your project’s objectives. We assist in selecting appropriate methods, designing research frameworks, and ensuring the reliability and validity of your study. Let us help you craft a clear and effective methodology for your academic research.",
    },
    // {
    //   icon: (
    //     <FaNetworkWired
    //       className="mb-1.5 me-1.5"
    //       style={{ height: "25px", width: "25px" }}
    //     />
    //   ),
    //   title: "N/w Communication",
    //   description:
    //     "Enhance your network and communication skills with our expert guidance. Learn about network protocols, wireless communication, and infrastructure design. Our support includes IP addressing, routing and switching, network security, and performance optimization. Build robust and scalable networks to meet modern communication demands.",
    // },
    // {
    //   icon: (
    //     <FaChalkboardTeacher
    //       className="mb-1.5 me-1.5"
    //       style={{ height: "25px", width: "25px", fontWeight: "bolder" }}
    //     />
    //   ),
    //   title: "Educational Technology",
    //   description:
    //     "Transform education with our educational technology services. We assist in implementing e-learning platforms, digital tools, and innovative teaching methods. Our expertise covers Learning Management Systems (LMS), interactive content creation, and technology integration in the classroom. Enhance educational experiences and outcomes through effective use of technology.",
    // },
    // {
    //   icon: (
    //     <TbAugmentedReality2
    //       className="mb-1.5 me-1.5"
    //       style={{ height: "25px", width: "25px" }}
    //     />
    //   ),
    //   title: "VR / AR",
    //   description:
    //     "Immerse yourself in VR and AR with our specialized support. Learn to create engaging virtual experiences, develop AR applications, and explore new realities. We provide guidance on 3D modeling, animation, and interactive design. Expand your creative and technical skills to develop cutting-edge VR and AR projects that captivate audiences.",
    // },
    // {
    //   icon: (
    //     <FaRegLightbulb
    //       className="mb-1.5 me-1.5"
    //       style={{ height: "25px", width: "25px" }}
    //     />
    //   ),
    //   title: "Innovation & Creativity",
    //   description:
    //     "Foster innovation and creativity with our expert guidance. We help you develop innovative projects, think creatively, and bring groundbreaking ideas to life. Our services include brainstorming techniques, design thinking, prototyping, and innovation management. Cultivate a mindset of creativity and drive transformative change in your field.",
    // },
  ];

  return (
    <React.Fragment>
      <div
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 p-0 sm:p-6 mt-5 max-w-8xl "
        style={{ justifyItems: "center" }}
      >
        {services.map((service, index) => (
          <Card
            key={index}
            sx={{
              maxWidth: 350,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              marginBottom: 2,
              background:
                "linear-gradient(79deg, rgba(0,66,100,0.8) 0%, rgba(0,21,20,0.8) 100%)",
              // border:"1px solid",
              // borderColor:"rgb(249,115,22,0.8"
            }}
          >
            <CardActionArea>
              <CardContent>
                <div className="flex justify-center items-center text-white	Dark component">
                  <Typography
                    className="text-blue-950	Dark"
                    style={{ fontWeight: "", color: "white" }}
                    gutterBottom
                    variant="h5"
                    component="div"
                  >
                    {service.title}
                  </Typography>
                </div>
                <Typography
                  variant="body2"
                  className="text-blue-950	Dark text-justify component"
                  style={{
                    maxHeight: "80px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    color: "white",
                  }}
                >
                  {service.description}
                </Typography>
              </CardContent>
            </CardActionArea>
            {service.description.length > 100 && (
              <Button
                size="small"
                color="primary"
                onClick={() => handleOpen(service)}
              >
                Read More
              </Button>
            )}
          </Card>
        ))}
      </div>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{selectedService?.title}</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            {selectedService?.description}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default ServicesGrid;

// import React, { useState } from "react";
// import {
//   FaLaptop,
//   FaNetworkWired,
//   FaChalkboardTeacher,
//   FaRegLightbulb,
// } from "react-icons/fa";
// import { TbAugmentedReality2 } from "react-icons/tb";
// import { GiCyberEye } from "react-icons/gi";
// import { RiCodeSSlashLine } from "react-icons/ri";
// import { GrCloudComputer } from "react-icons/gr";
// import { SiDatastax } from "react-icons/si";
// import { GoGraph } from "react-icons/go";
// import { BiAnalyse } from "react-icons/bi";
// import { MdOutlineBusinessCenter } from "react-icons/md";
// import {
//   Card,
//   CardActionArea,
//   CardContent,
//   Typography,
//   Button,
//   Dialog,
//   DialogContent,
//   DialogTitle,
//   DialogActions,
// } from "@mui/material";

// interface Service {
//   icon: JSX.Element;
//   title: string;
//   description: string;
// }

// const ServicesGrid: React.FC = () => {
//   const [open, setOpen] = useState(false);
//   const [selectedService, setSelectedService] = useState<Service | null>(null);

//   const handleOpen = (service: Service) => {
//     setSelectedService(service);
//     setOpen(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//     setSelectedService(null);
//   };

//     const services: Service[] = [
//     {
//       icon: (
//         <SiDatastax
//           className="mb-1.5 me-1.5"
//           style={{ height: "25px", width: "25px" }}
//         />
//       ),
//       title: "Data Science",
//       description:
//         "Transform your data science assignments into exemplary projects with our PhD-level support. We assist with data analysis, visualization, and predictive modeling using R, Python, and more. Whether you are dealing with big data, statistical analysis, or machine learning algorithms, our experts ensure your projects meet the highest academic and professional standards. Gain hands-on experience with real-world datasets and cutting-edge tools.",
//     },
//     {
//       icon: (
//         <GoGraph
//           className="mb-1.5 me-1.5"
//           style={{ height: "25px", width: "25px" }}
//         />
//       ),
//       title: "Machine Learning",
//       description:
//         "Master machine learning with our expert guidance on assignments involving algorithms, models, and applications. Elevate your knowledge with real-world applications. Our services cover supervised and unsupervised learning, deep learning, and reinforcement learning. We provide step-by-step assistance, from data preprocessing to model evaluation, ensuring you understand each aspect of machine learning comprehensively.",
//     },
//     {
//       icon: (
//         <BiAnalyse
//           className="mb-1.5 me-1.5"
//           style={{ height: "25px", width: "25px" }}
//         />
//       ),
//       title: "Market Analysis",
//       description:
//         "Excel in market analysis with our tailored assignment assistance. We help you conduct thorough research, analyze trends, and interpret data for strategic decision-making. Our support includes competitive analysis, customer segmentation, market forecasting, and data visualization techniques. Learn to apply analytical tools and methodologies to gain actionable insights and drive business growth.",
//     },
//     {
//       icon: (
//         <FaLaptop
//           className="mb-1.5 me-1.5"
//           style={{ height: "25px", width: "25px" }}
//         />
//       ),
//       title: "Artificial Intelligence",
//       description:
//         "Master artificial intelligence with our personalized guidance. We assist you in navigating complex algorithms, understanding AI trends, and leveraging data for innovative solutions. Our support spans natural language processing, computer vision, robotics, and AI ethics. Stay ahead in the AI field with practical knowledge and expertise in implementing AI-driven applications and systems.",
//     },
//     {
//       icon: (
//         <GiCyberEye
//           className="mb-1.5 me-1.5"
//           style={{ height: "25px", width: "25px" }}
//         />
//       ),
//       title: "Cyber Security",
//       description:
//         "Secure your data and systems with our expert cyber security services. We provide comprehensive support in vulnerability assessment, threat analysis, and security protocols. Our services include penetration testing, incident response, encryption techniques, and compliance with industry standards. Protect your digital assets and enhance your understanding of cyber security strategies and tools.",
//     },
//     {
//       icon: (
//         <GrCloudComputer
//           className="mb-1.5 me-1.5"
//           style={{ height: "25px", width: "25px" }}
//         />
//       ),
//       title: "Cloud Computing",
//       description:
//         "Unlock the potential of cloud computing with our specialized assignment services. Learn to deploy and manage scalable applications on platforms like AWS, Azure, and Google Cloud. We offer guidance on cloud architecture, migration strategies, cost optimization, and security measures. Gain practical skills in leveraging cloud services for efficiency and innovation.",
//     },
//     // {
//     //   icon: (
//     //     <MdOutlineBusinessCenter
//     //       className="mb-1.5 me-1.5"
//     //       style={{ height: "25px", width: "25px" }}
//     //     />
//     //   ),
//     //   title: "IoT",
//     //   description:
//     //     "Master the Internet of Things with our personalized guidance. We assist you in understanding IoT architectures, integrating smart devices, and leveraging connectivity for innovative solutions. Our support covers sensor networks, data acquisition, IoT security, and real-time analytics. Transform your understanding of IoT and create connected systems that drive smart applications.",
//     // },
//     // {
//     //   icon: (
//     //     <RiCodeSSlashLine
//     //       className="mb-1.5 me-1.5"
//     //       style={{ height: "25px", width: "25px" }}
//     //     />
//     //   ),
//     //   title: "Blockchain Technology",
//     //   description:
//     //     "Dive into blockchain technology with our comprehensive support. We help you understand decentralized systems, smart contracts, and cryptocurrency applications. Explore blockchain platforms like Ethereum and Hyperledger, and gain hands-on experience in developing and deploying blockchain solutions. Stay at the forefront of technological innovation with our expert guidance.",
//     // },
//     // {
//     //   icon: (
//     //     <FaNetworkWired
//     //       className="mb-1.5 me-1.5"
//     //       style={{ height: "25px", width: "25px" }}
//     //     />
//     //   ),
//     //   title: "N/w Communication",
//     //   description:
//     //     "Enhance your network and communication skills with our expert guidance. Learn about network protocols, wireless communication, and infrastructure design. Our support includes IP addressing, routing and switching, network security, and performance optimization. Build robust and scalable networks to meet modern communication demands.",
//     // },
//     // {
//     //   icon: (
//     //     <FaChalkboardTeacher
//     //       className="mb-1.5 me-1.5"
//     //       style={{ height: "25px", width: "25px", fontWeight: "bolder" }}
//     //     />
//     //   ),
//     //   title: "Educational Technology",
//     //   description:
//     //     "Transform education with our educational technology services. We assist in implementing e-learning platforms, digital tools, and innovative teaching methods. Our expertise covers Learning Management Systems (LMS), interactive content creation, and technology integration in the classroom. Enhance educational experiences and outcomes through effective use of technology.",
//     // },
//     // {
//     //   icon: (
//     //     <TbAugmentedReality2
//     //       className="mb-1.5 me-1.5"
//     //       style={{ height: "25px", width: "25px" }}
//     //     />
//     //   ),
//     //   title: "VR / AR",
//     //   description:
//     //     "Immerse yourself in VR and AR with our specialized support. Learn to create engaging virtual experiences, develop AR applications, and explore new realities. We provide guidance on 3D modeling, animation, and interactive design. Expand your creative and technical skills to develop cutting-edge VR and AR projects that captivate audiences.",
//     // },
//     // {
//     //   icon: (
//     //     <FaRegLightbulb
//     //       className="mb-1.5 me-1.5"
//     //       style={{ height: "25px", width: "25px" }}
//     //     />
//     //   ),
//     //   title: "Innovation & Creativity",
//     //   description:
//     //     "Foster innovation and creativity with our expert guidance. We help you develop innovative projects, think creatively, and bring groundbreaking ideas to life. Our services include brainstorming techniques, design thinking, prototyping, and innovation management. Cultivate a mindset of creativity and drive transformative change in your field.",
//     // },
//   ];

//   // Create an array of arrays to group services into columns
//   const columns = Array.from({ length: 4 }, (_, i) =>
//     services.slice(i * 4, i * 4 + 4)
//   );

//   return (
//     <React.Fragment>
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 p-0 sm:p-6 mt-5 max-w-xl">
//         {columns.map((column, colIndex) => (
//           <div key={colIndex} className="flex flex-col gap-4">
//             {column.map((service, index) => (
//               <Card
//                 key={index}
//                 sx={{
//                   maxWidth: 350,
//                   display: "flex",
//                   flexDirection: "column",
//                   justifyContent: "space-between",
//                   marginBottom: 2,
//                   background: "linear-gradient(79deg, rgba(0,66,100,0.9) 0%, rgba(0,21,20,0.9) 100%)",
//                 }}
//               >
//                 <CardActionArea>
//                   <CardContent>
//                     <div className="flex justify-center items-center text-white">
//                       {service.icon}
//                       <Typography
//                         className="text-blue-950"
//                         style={{ fontWeight: "bolder", color: "white" }}
//                         gutterBottom
//                         variant="h5"
//                         component="div"
//                       >
//                         {service.title}
//                       </Typography>
//                     </div>
//                     <Typography
//                       variant="body2"
//                       className="text-blue-950 text-justify"
//                       style={{
//                         maxHeight: "80px",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                         color: "white",
//                       }}
//                     >
//                       {service.description}
//                     </Typography>
//                   </CardContent>
//                 </CardActionArea>
//                 {service.description.length > 100 && (
//                   <Button size="small" color="primary" onClick={() => handleOpen(service)}>
//                     Read More
//                   </Button>
//                 )}
//               </Card>
//             ))}
//           </div>
//         ))}
//       </div>

//       <Dialog open={open} onClose={handleClose}>
//         <DialogTitle>{selectedService?.title}</DialogTitle>
//         <DialogContent>
//           <Typography variant="body1">
//             {selectedService?.description}
//           </Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleClose} color="primary">
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </React.Fragment>
//   );
// };

// export default ServicesGrid;
